import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { TAB_PARAM_KEYS } from "@/constants/TabKeys";
import { useModelLinkInline } from "@/modules/model-link";

export const useIsFormEnginePreviewMode = () => {
  const { t } = useTranslation();
  const { search, pathname } = useLocation();
  const assetTypesPath = useModelLinkInline("assettype");
  const interventionTemplatesPath = useModelLinkInline("interventiontemplate");

  const previewTab = t("form:preview").toLowerCase();
  const currentTab = new URLSearchParams(search ?? {}).get(
    TAB_PARAM_KEYS.CONTEXT_TAB_KEY
  );
  const isPreviewTab = !currentTab || currentTab.toLowerCase() === previewTab;
  const isAssetTypesPath = pathname?.startsWith(assetTypesPath);
  const isInterventionTemplatesPath = pathname?.startsWith(
    interventionTemplatesPath
  );

  const isPreviewMode =
    (isAssetTypesPath || isInterventionTemplatesPath) && isPreviewTab;

  return !!isPreviewMode;
};
